import { Injectable } from '@angular/core';
import {RequestProvider} from "../request/request";

/*
  Generated class for the VehicleProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class VehicleProvider {

  constructor(
    public request: RequestProvider
  ) {

  }

  get(name: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`vehicle/${name}`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve({});
      });
    });
  }

  save(vehicle: any, images: any) {
    let data = {
      'images': images,
      'vehicle': vehicle
    };

    return new Promise((resolve, reject) => {
      this.request.post(`vehicle/save`, data, true).subscribe(data => {
        resolve(data.id);
      }, err => {
        resolve({});
      });
    });
  }

  getImages(vehicleId: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`vehicle-images/${vehicleId}`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve({});
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/vehicle/vehicle.ts